import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { withRouter } from 'react-router-dom';
import {
	setPageHeaderTextActionCreator,
} from 'plugins/store/reducers/common.reducer';

import withStyles from '@material-ui/core/styles/withStyles';
import appointmentTypes from 'utils/enums/appointment-types.enum';
import layoutNames from 'utils/enums/layout-names.enum';
import schedulerViewMode from 'utils/enums/scheduler-view-mode.enum';

// @material-ui
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';

// core components
import LoadingIndicator from 'components/LoadingIndicator/LoadingIndicator';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import Card from 'components/Card/Card';
import CardHeader from 'components/Card/CardHeader';
import CardIcon from 'components/Card/CardIcon';
import CalendarView from './CalendarView';
import ListView from './ListView';

import styles from 'assets/jss/material-dashboard-pro-react/components/schedulerPage';

class Scheduler extends React.Component {
	viewName = 'Scheduler';

	state = {
		loading: false,
	};

	componentDidMount() {
		this.props.setPageHeaderText(this.viewName);
	}

	componentWillUnmount() {
		this.props.setPageHeaderText('');
	}

	createAppointment = () => {
		const historyObject = {
			pathname: 'scheduler/create-call',
		}

		this.props.history.push(historyObject);
	}

	editAppointment = (id, type) => {
		if (type === appointmentTypes.VACATION) {
			this.props.history.push(`/${layoutNames.portal}/scheduler/vacation/${id}`);
		} else if (type === appointmentTypes.CALL){
			this.props.history.push(`/${layoutNames.portal}/scheduler/call/${id}`);
		}
	}

	createVacation = () => {
		this.props.history.push(`/${layoutNames.portal}/scheduler/create-vacation`);
	}

	setLoading = (loading) => {
		this.setState({ loading });
	}

	render() {
		const { classes, viewMode } = this.props;
		const loading = this.state.loading && <div className={classes.loading}><LoadingIndicator /></div>;
		const cardHeaderStyle = viewMode === schedulerViewMode.LIST
			? styles.cardHeader
			: {};

		return (
			<GridContainer className={classes.wrapper}>
				<GridItem xs={12}>
					<Card>
						<CardHeader style={cardHeaderStyle} color="primary" icon>
							<CardIcon color="primary">
								<CalendarTodayIcon />
							</CardIcon>
						</CardHeader>
						{loading}
						{
							viewMode === schedulerViewMode.CALENDAR
								?	(<CalendarView
									setLoading={this.setLoading}
									createAppointment={this.createAppointment}
									editAppointment={this.editAppointment}
									createVacation={this.createVacation}
								/>)
								: <ListView
										setLoading={this.setLoading}
									/>
						}
					</Card>
				</GridItem>
			</GridContainer>
		)
	}
}

const mapStateToProps = (state) => ({
	viewMode: state.common.schedulerSettings.viewMode,
});

const mapDispatchToProps = (dispatch) => ({
	setPageHeaderText: bindActionCreators(
		setPageHeaderTextActionCreator,
		dispatch),
});

export default compose(
	connect(mapStateToProps, mapDispatchToProps),
	withStyles(styles),
	withRouter,
)(Scheduler);

